import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';
import Logo from '../../assets/images/logo_t.png';
import { FaSignOutAlt, FaTachometerAlt, FaUser } from 'react-icons/fa';

const Navbar = () => {
  const { isLoggedIn, currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Mobile menu state
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(prev => !prev);
  };

  // Close mobile menu
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Handle logout
  const handleLogout = () => {
    logout();
    navigate('/');
    closeMobileMenu();
  };

  // Check if a path is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="navbar">
      <div className="container navbar-container">
        <div className="navbar-logo">
          <img
            src={Logo}
            alt="CVance Logo"
            className="logo-img"
          />
          <Link to="/" onClick={closeMobileMenu}>
            <span className="logo-text">CVance</span>
          </Link>
        </div>

        {/* Hamburger menu for mobile */}
        <button
          className={`navbar-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="toggle-bar"></span>
          <span className="toggle-bar"></span>
          <span className="toggle-bar"></span>
        </button>

        {/* Main navigation */}
        <nav className={`navbar-nav ${mobileMenuOpen ? 'open' : ''}`}>
          <ul className="navbar-nav-list">
            <li className="navbar-nav-item">
              <Link
                to="/"
                className={`navbar-nav-link ${isActive('/') ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                Home
              </Link>
            </li>

            {isLoggedIn ? (
              // Links for logged in users
              <>
                <li className="navbar-nav-item">
                  <Link
                    to="/dashboard"
                    className={`navbar-nav-link ${isActive('/dashboard') ? 'active' : ''}`}
                    onClick={closeMobileMenu}
                  >
                    Dashboard
                  </Link>
                </li>
                <li className="navbar-nav-item">
                  <Link
                    to="/profile"
                    className={`navbar-nav-link ${isActive('/profile') ? 'active' : ''}`}
                    onClick={closeMobileMenu}
                  >
                    Profile
                  </Link>
                </li>
                <li className="navbar-nav-item">
                  <Link
                    to="/tailor"
                    className={`navbar-nav-link ${isActive('/tailor') ? 'active' : ''}`}
                    onClick={closeMobileMenu}
                  >
                    Tailor Resume
                  </Link>
                </li>
              </>
            ) : (
              // Links for guests
              <>
                <li className="navbar-nav-item">
                  <Link
                    to="/login"
                    className={`navbar-nav-link ${isActive('/login') ? 'active' : ''}`}
                    onClick={closeMobileMenu}
                  >
                    Login
                  </Link>
                </li>
                <li className="navbar-nav-item">
                  <Link
                    to="/register"
                    className={`navbar-nav-link ${isActive('/register') ? 'active' : ''}`}
                    onClick={closeMobileMenu}
                  >
                    Register
                  </Link>
                </li>
              </>
            )}
          </ul>

          {/* User dropdown for logged in users */}
          {isLoggedIn && currentUser && (
            <div className="navbar-user">
              <button className="navbar-user-button">
                <span className="user-name">
                  {currentUser?.first_name} {currentUser?.last_name}
                </span>
                <span className="user-avatar">
                  {currentUser?.first_name.charAt(0)}
                  {currentUser?.last_name.charAt(0)}
                </span>
              </button>

              <div className="navbar-dropdown">
                <Link
                  to="/profile"
                  className="dropdown-item"
                  onClick={closeMobileMenu}
                >
                  <FaUser /> My Profile
                </Link>
                <Link
                  to="/dashboard"
                  className="dropdown-item"
                  onClick={closeMobileMenu}
                >
                  <FaTachometerAlt /> Dashboard
                </Link>
                <button
                  className="dropdown-item"
                  onClick={handleLogout}
                >
                  <FaSignOutAlt /> Logout
                </button>
              </div>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;